import { render, staticRenderFns } from "./UtilityBar.vue?vue&type=template&id=4bea645a&"
import script from "./UtilityBar.vue?vue&type=script&lang=js&"
export * from "./UtilityBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports